// extracted by mini-css-extract-plugin
export default {"root":"dropdown_root__YysLd","rootShrinkWrap":"dropdown_rootShrinkWrap__uQroH","panel":"dropdown_panel__+7SKL"};